import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class RelatorioConvenioService {
  private readonly base = `${environment.apiUrl}/v1/convenio-amil`;

  constructor(private readonly http: HttpClient) {}

  individuais(pdf: File): Observable<HttpResponse<Blob>> {
    return this.enviar('planilhas', pdf);
  }

  resumo(pdf: File): Observable<HttpResponse<Blob>> {
    return this.enviar('resumo', pdf);
  }

  private enviar(rota: string, pdf: File): Observable<HttpResponse<Blob>> {
    const form = new FormData();
    form.append('pdf', pdf, pdf.name);
    return this.http.post(`${this.base}/${rota}`, form, {
      responseType: 'blob',
      observe: 'response'
    });
  }
}
